import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import './sass/custom.sass';
import tr from 'vuetify/es5/locale/tr';


Vue.use(Vuetify);


export default new Vuetify({
  lang: {
    locales: { tr },
    current: 'tr',
  },
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    // dark: true,
    themes: {
      // dark: {
      //   primary: '#FB8C00',
      // },
      light: {
        primary: '#FFAB00',
        secondary: '#FF6F00',
        'base-primary': '#FFA726',
        'base-secondary': '#FFA000',
        'base-button': '#FFCA28',
      },
    },
  },
});
